<template>
  <!-- Preloader -->
  <div :class="['preloader', preloaderHidden ? 'hidden' : '']">
    <div class="preloader-inner">
      <div class="preloader-ring"></div>
      <p class="preloader-text">Orel Medical</p>
    </div>
  </div>

  <!-- Page transitions -->
  <RouterView v-slot="{ Component, route }">
    <Transition name="page" mode="out-in">
      <component :is="Component" :key="route.path" />
    </Transition>
  </RouterView>

  <!-- Scroll-to-top -->
  <button
    :class="['scroll-top-btn', showScrollTop ? 'visible' : '']"
    @click="scrollToTop"
    aria-label="Scroll to top"
  >
    <i class="fa-solid fa-angles-up text-sm"></i>
  </button>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const preloaderHidden = ref(false)
const showScrollTop   = ref(false)

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
const handleScroll = () => { showScrollTop.value = window.scrollY > 400 }

onMounted(() => {
  const hide = () => { preloaderHidden.value = true }
  if (document.readyState === 'complete') {
    setTimeout(hide, 400)
  } else {
    window.addEventListener('load', () => setTimeout(hide, 400), { once: true })
  }
  window.addEventListener('scroll', handleScroll, { passive: true })
})
onUnmounted(() => window.removeEventListener('scroll', handleScroll))
</script>
